module.exports = {
  InteractiveItem: {
    PluginName: "Interactive Item",
    Empty: "No interactive item",
    Edit: "Edit",
    AiEdit: "Edit with AI",
    AiEditHint:
      "Say what should change — the look, the content or the behaviour. Applied on top of the current item.",
    AiEditPlaceholder:
      "e.g. make the cards more colourful · add one more question · tap instead of drag",
    AiEditRunning: "Applying the change",
    AiEditApply: "Apply",
    AiEditUnavailable:
      "This item cannot be AI-edited (it has no source). You can generate a new one.",
    EditHint: "Edit the content — no regeneration needed",
    TryOn: "Try",
    TryOff: "✓ Trying",
    TryOnHint: "Turn on to play the activity",
    TryOffHint: "Turn off to move the box",

    ModalTitle: "Add an Interactive Item",
    GoalQuestion: "What do you want it to do?",
    Suggestions: "Three suggestions",
    ShowAll: "Show every type",
    ModeWrite: "Write a prompt",
    ModeNarration: "From the narration",
    NoNarration: "This scene has no narration",
    NeedInput: "This scene has no narration — type a topic above.",
    PromptPlaceholder: "What is it about? e.g. how to use a fire extinguisher",
    PromptOverride: "A different topic instead of the narration (optional)",
    AccentColor: "Main colour",
    AccentColorNote: "Surfaces, tints and gradients are derived from it",
    CustomColor: "Custom colour",
    AllTypes: "Every type",
    Thinking: "Reading the narration…",
    Generating: "Writing the activity",
    GeneratingMeta:
      "This can take a few minutes — you can close the dialog, the job keeps running.",
    Again: "Try something else",
    Add: "Add to scene",
    Scored: "scored",
    Unscored: "not scored",
    SeeExample: "See an example",
    ExampleTag: "example",
    ExampleHint:
      "A real generated output — try it. The content is placeholder; this is the shape your narration will produce.",

    EditorHint: "Change the content here — no regeneration, no credits spent.",
    Apply: "Apply",
    AddRow: "Add",
    MinRows: "Cannot go lower",
    ModelAuto: "Automatic (Sonnet 5.5)",
    ModelSonnet: "Sonnet 5.5",
    ModelOpus: "Opus 5.5",
  },
};
